import { useEffect, useState } from "react";

export function Confetti({ fire }) {
  const [pieces, setPieces] = useState([]);
  useEffect(() => {
    if (!fire) return;
    const colors = ["#A24936", "#D4AF37", "#5E7153", "#1F1E1C", "#8A94A6"];
    const arr = Array.from({ length: 90 }).map((_, i) => ({
      id: i, left: Math.random() * 100, delay: Math.random() * 0.6,
      dur: 1.6 + Math.random() * 1.4, color: colors[i % colors.length],
      rot: Math.random() * 360, size: 6 + Math.random() * 6,
    }));
    setPieces(arr);
    const t = setTimeout(() => setPieces([]), 3500);
    return () => clearTimeout(t);
  }, [fire]);

  if (pieces.length === 0) return null;
  return (
    <div className="fixed inset-0 pointer-events-none z-[100] overflow-hidden" data-testid="confetti">
      {pieces.map((p) => (
        <span key={p.id} style={{
          position: "absolute", top: "-20px", left: `${p.left}%`, width: p.size, height: p.size * 1.4,
          background: p.color, transform: `rotate(${p.rot}deg)`, borderRadius: 2,
          animation: `confetti-fall ${p.dur}s ${p.delay}s ease-in forwards`,
        }} />
      ))}
      <style>{`@keyframes confetti-fall{to{transform:translateY(105vh) rotate(720deg);opacity:.2}}`}</style>
    </div>
  );
}
